<template>
  <UnitsContext>
    <RouterView></RouterView>
  </UnitsContext>
</template>

<script setup lang="ts">
import { useAccountMembershipsContext } from '@/composables/deepadmin/use-account-memberships-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import { useSubscriptionFeaturesContext } from '@/composables/deepadmin/use-subscription-features.context.ts'
import UnitsContext from '@/components/deepadmin/units/UnitsContext.vue'

definePage({
  meta: {
    breadcrumbLabelKey:
      'navigation.organization.settings.security.domain_verifications.title',
  },
})

const { selectedOrganization, isVerified } = useAccountMembershipsContext()
const { hasUnlockedDomainVerification } = useSubscriptionFeaturesContext()

usePageAccess(
  computed(
    () =>
      !isVerified(selectedOrganization.value) ||
      !hasUnlockedDomainVerification.value,
  ),
)
</script>
